export enum PositionColumnsEnum {
	ticker = 'ticker',
	marketValue = 'marketValue',
	quantity = 'quantity',
	priceAveragePrice = 'priceAveragePrice',
	share = 'share',
	profitabilityPerDay = 'profitabilityPerDay',
	profitability = 'profitability',
}
